import { Show } from 'solid-js';
import { WrappedImage } from '../image-component/wrapped-image';
import { LinkSpotProps } from './link-spot';
import { Dynamic } from 'solid-js/web';


const Children = (props: Omit<LinkSpotProps, 'hash'>) => {
    const { image, heading, headingTag, variant, description, url } = props;

    return (
        <>
            <Show when={image}>
                <WrappedImage image={image} aspectRatio='original' width={300} height='auto' />
            </Show>

            <Dynamic
                component={headingTag || 'h2'}
                class='text-headerL font-paytone text-white'
            >
                {heading}
            </Dynamic>
            <Show when={variant === 'extended'}>
                <div class='w-full h-full flex flex-col flex-1 gap-s justify-between'>
                    <p class='text-paragraphS text-white text-left'>{description}</p>
                    <Show when={!!url}>
                        <div class='w-full flex justify-end items-end self-stretch animate-move-right-back group-hover:animate-move-right group-focus:animate-move-right'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="30" viewBox="0 0 34 30" fill="none" opacity="0.4">
                                <path d="M1 15H33" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M19 1L33 15L19 29" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </Show>
                </div>
            </Show>
        </>
    );
};

export default Children;
